export enum QuarterOverviewFileTypeEnum {
  LMS = 'lms',
  CHECKOUT = 'checkout',
}
